export enum SmallPushVariant {
  default = 'default',
  imageLast = 'imageLast',
}
